import { Action } from 'redux';

import { RequestStatus } from './request';

export interface ResetPasswordPayload {
  email: string;
}

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESETTING_PASSWORD = 'RESETTING_PASSWORD';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const RESET_PASSWORD_COMPLETED = 'RESET_PASSWORD_COMPLETED';

export interface IResetPasswordFailedAction extends Action {
  payload: JSX.Element;
}

export type ResetPasswordActionTypes = Action | IResetPasswordFailedAction;

export interface ResetPasswordState {
  error?: JSX.Element;
  status: RequestStatus;
}
